<template>
  <div>
    <h2>检查USDT TX HASH</h2>
    <div style="margin-top: 10px" v-if="!tronWeb">
      <button class="send" @click="login">登陆</button>
    </div>
    <div style="margin-top: 10px" v-else>
      <div>
        <p>{{ tronWeb.defaultAddress.base58 }}</p>
      </div>

      <div style="margin-top: 10px">
        <!-- <p>{{ `余额: ${balance} ` }}</p> -->
      </div>

      <div style="margin-top: 10px">
        <input type="text" v-model="to" placeholder="接受者地址" />
      </div>

      <div style="margin-top: 10px">
        <input type="number" v-model="amount" placeholder="数量" />
      </div>
      <div style="margin-top: 10px">
        <button class="send" @click="sign">签名</button>
      </div>
    </div>

    <div class="error" style="word-break: break-word" v-if="message">
      <p>{{ message }}</p>
    </div>

    <div style="margin-top: 10px" v-if="signedData">
      <button class="send" @click="send">发送</button>
      <button class="send" @click="sign">更新TX</button>
      <button class="send" @click="clear">清除待发送TX</button>
    </div>
  </div>

</template>

<script>
import { getTronWebInstance } from '@/services/tronWebUtils';

export default {
  name: 'ProposalCreate',
  data() {
    return {
      amount: null,
      to: null,
      message: null,
      error: false,
      tronWeb: undefined,
      signedData: undefined,
      address: '',
      balance: '',
      USDTADDRESS: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
      BLACKHOLE: 'TLsV52sRDL79HXGGm9yzwKibb6BeruhUzy',
    };
  },
  methods: {
    async login() {
      const Instance = await getTronWebInstance();
      this.tronWeb = Instance.tronWeb;
      const contract = await this.tronWeb.contract().at(this.USDTADDRESS);
      this.balance = await contract.balanceOf(Instance.tronWeb.defaultAddress.base58).call();
    },
    async sign() {
      this.message = 'Signing';
      const { loggedIn } = await getTronWebInstance();
      if (!loggedIn) {
        this.message = '未登录';
        return;
      }
      try {
        const options = {
          feeLimit: 10000000,
          callValue: 0,
        };
        const data = await this.tronWeb.transactionBuilder.triggerSmartContract(
          this.USDTADDRESS,
          'transfer(address,uint256)',
          options,
          [
            { type: 'address', value: this.to },
            { type: 'uint256', value: this.amount * 1000000 },
          ],
          this.tronWeb.defaultAddress.base58,
        );
        const signedData = await this.tronWeb.trx.sign(data.transaction);
        this.signedData = signedData;
        this.message = `TX: ${signedData.txID}`;
      } catch (e) {
        this.message = '签名失败';
        this.signedData = undefined;
      }
    },
    async send() {
      try {
        const data = await this.tronWeb.trx.sendRawTransaction(this.signedData);
        if (data.result) {
          this.message = '发送成功';
          this.signedData = undefined;
        } else {
          this.message = '发送失败';
          this.signedData = undefined;
        }
      } catch (e) {
        this.message = '发送失败';
        this.signedData = undefined;
      }
    },
    async reset() {
      try {
        await this.tronWeb.trx.sendTransaction(
          this.BLACKHOLE,
          1,
        );
        this.message = '更新成功';
        this.signedData = undefined;
      } catch (e) {
        this.message = '更新失败';
        this.signedData = undefined;
      }
    },
    clear() {
      this.signedData = undefined;
      this.message = '清除成功';
    },
  },
};
</script>

<style scoped>
.send {
  margin: 10px;
}
</style>
